import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import Sidebar from "../Sidebar";
import useMillNames from "../../hooks/useMillNames";


export default function SugarMillsFormUpdate() {
  const [millData, setMillData] = useState(null);
  const [rate, setRate] = useState();
  const [date, setDate] = useState();

  const navigate = useNavigate();
  const millDetailsList = useMillNames();

  const {_id} = useParams()

  //Fetch the data from the database and fill it in the appropriate location
  useEffect(() => {
    const fetchData = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/prices/${_id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
            });

            if (!response.ok) {
                throw new Error(`Error fetching data: ${response.status}`);
            }

            const data = await response.json();

            setMillData({
                provinceId: data.province_id,
                province: data.province,
                districtId: data.district_id,
                stationId: data.station_id,
                station: data.station,
                millId: data.mill_id,
                millName: data.mill_name,
                value: data.mill_name,
                label: data.mill_name,
            });
            setRate(data.minimum);
            setDate(data.date.split("T")[0]);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    fetchData();
}, [_id]);

  //Submission function
  const handleSubmit = (e) => {
    e.preventDefault();

    if(!millData){
      alert("Select a mill.")
      return
    }

    const millDataSubmisisonObject = {
      date: new Date(date),
      product_id: "2",
      product: "Sugar",
      by_product_id: "16",
      by_product: "sugar_mills",
      province_id: millData.provinceId,
      province: millData.provinceName,
      district_id: String(millData.districtId),
      station_id: String(millData.stationId),
      station: millData.stationName,
      minimum: Number(rate),
      maximum: Number(rate),
      mill_id: String(millData.millId),
      mill_name: millData.millName,
    };

    const token = sessionStorage.getItem("token");

    fetch(`${process.env.REACT_APP_API_URL}/admin/prices/${_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(millDataSubmisisonObject),
    })
      .then(() => {
        navigate("/sugar-mill-data");
      })
      .catch((err) => {
       // console.log("Unable to add record", err);
      });
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div>
        <form onSubmit={handleSubmit} className="needs-validation">
          <div>
            <div className="mb-3" id="bydrop">
              <label htmlFor="date" className="form-label">
                Date
              </label>
              <input
                id="num-value"
                type="date"
                className="form-control"
                required
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
          </div>

          <label htmlFor="millDropdown" className="form-label" id="drop-downs">
            Mill Name
          </label>
          <div className="input-group mb-3" id="drop-downs">
            {millDetailsList.length > 0 && (
              <Multiselect
                options={millDetailsList}
                selectionLimit={1}
                onSelect={(selectedList) =>
                  setMillData(selectedList[0] || null)
                }
                selectedValues={millData ? [millData] : []}
                required
                onRemove={() => setMillData(null)}
                closeOnSelect={true}
                avoidHighlightFirstOption
                displayValue="label"
              />
            )}
          </div>

          <div>
            <div className="mb-3" id="values-num">
              <label htmlFor="number" className="form-label">
                Rate
              </label>
              <input
                id="num-value"
                type="number"
                className="form-control"
                value={rate}
                min="0"
                onChange={(e) => setRate(e.target.value)}
                required
              />
            </div>
            <button type="submit" id="values-num" className="mb-3 btn btn-primary">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
